import { useState, useCallback } from 'react';
import { AuthHelper } from '../../../common/helper';
import { useInjection } from '../../../di_container/InjectionProvider';
import { useClinicUser } from '../clinic/ClinicUserHooks';
export const useAuth = () => {
    const { container } = useInjection();
    const { jobClinic } = useClinicUser();
    // Repository
    const authRepository = container.resolve('AuthRepository');
    const localDatabaseRepository = container.resolve('LocalDatabaseRepository');
    const imoryApiRepository = container.resolve('ImoryApiRepository');
    // State
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    // UseCase
    const loginWithEmail = useCallback(async (email, password) => {
        var _a;
        if (loading)
            return;
        setLoading(true);
        try {
            setError('');
            const auth = await authRepository.loginWithEmail(email, password, 'LOCAL');
            const tokenResult = await ((_a = auth.user) === null || _a === void 0 ? void 0 : _a.getIdTokenResult(true));
            if (tokenResult !== undefined) {
                await localDatabaseRepository.save('firebaseAuthToken', tokenResult.token);
                if (AuthHelper.isUserType('adminUser', tokenResult)) {
                    return 'adminUser';
                }
                else if (AuthHelper.isUserType('clinicUser', tokenResult)) {
                    return 'clinicUser';
                }
            }
            console.log('Finished logined');
        }
        catch (e) {
            console.error('error', e);
            setError(e.message);
            setLoading(false); // Redirectの影響によりcatchだけで行う
        }
    }, [authRepository, loading, localDatabaseRepository]);
    const logout = useCallback(async () => {
        if (loading)
            return;
        setLoading(true);
        try {
            await authRepository.logout();
            await localDatabaseRepository.remove('firebaseAuthToken');
        }
        catch (e) {
            setError(e.message);
            setLoading(false); // Redirectの影響によりcatchだけで行う
        }
    }, [authRepository, loading, localDatabaseRepository]);
    const updateEmail = useCallback(async (password, newEmail, isRegisteredStripeCustomer) => {
        if (loading)
            return;
        setLoading(true);
        try {
            if (isRegisteredStripeCustomer) {
                await imoryApiRepository.updateStripeEmail(newEmail);
            }
            await authRepository.updateEmail(password, newEmail);
            await authRepository.sendEmailVerification();
            if (jobClinic !== undefined) {
                jobClinic.email = newEmail;
                await jobClinic.update();
            }
            setLoading(false);
        }
        catch (e) {
            setLoading(false);
            console.error('error', e);
            throw e;
        }
    }, [authRepository]);
    const updatePassword = useCallback(async (oldPassword, newPassword) => {
        if (loading)
            return;
        setLoading(true);
        try {
            await authRepository.updatePassword(oldPassword, newPassword);
            setLoading(false);
        }
        catch (e) {
            setLoading(false);
            console.error('error', e);
            throw e;
        }
    }, [authRepository]);
    const sendPasswordResetEmail = useCallback(async (email) => {
        if (loading)
            return;
        setLoading(true);
        try {
            await authRepository.sendPasswordResetEmail(email);
            setLoading(false);
        }
        catch (e) {
            setLoading(false);
            console.error('error', e);
            throw e;
        }
    }, [authRepository]);
    return {
        loginWithEmail,
        logout,
        updateEmail,
        updatePassword,
        sendPasswordResetEmail,
        loading,
        error,
    };
};
